<template>
	<section>
		<el-row class="container">
			<el-col :span="24">
				<el-col :span="4">
					<h3 style="margin-top: 4px;">账户详情</h3>
				</el-col>
				<el-col :span="6">
					<label>累计购买：</label>
					<el-input style="width: 200px;" size="small" readonly v-model="userInfo.grand_total_purchase" :disabled="true" placeholder="累计购买"></el-input>
				</el-col>
				<el-col :span="6">
					<label>累计划拨：</label>
					<el-input style="width: 200px;" size="small" readonly v-model="userInfo.grand_total_transfer" :disabled="true" placeholder="累计划拨"></el-input>
				</el-col>
			</el-col>
		</el-row>
		<el-row class="container">
		<!--工具条-->
			<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
				<el-form :inline="true" :model="filters">
					<el-form-item label="购买数量：">
						<el-input size="small" v-model="filters.num" clearable placeholder="购买数量"></el-input>
					</el-form-item>
					<el-form-item label="交易编号：">
						<el-input size="small" v-model="filters.order_id" clearable placeholder="交易编号"></el-input>
					</el-form-item>
					<el-form-item label="时间：">
						<el-date-picker
								size="small"
								v-model="buyTime"
								value-format="yyyy-MM-dd"
								type="daterange"
								align="right"
								clearable
								unlink-panels
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								:picker-options="pickerOptions">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" v-on:click="getBusinessPurchaserRecordList">充值查询</el-button>
						<el-button type="primary" size="small" v-on:click="handleExport">导出</el-button>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<!--列表-->
		<el-table
				:data="purchaserRecordList"
				id="purchaserRecordList"
				highlight-current-row
				:height="h"
				border
				v-loading="loading"
				@selection-change="selsChange"
				style="width: 100%;">
			<el-table-column type="index" width="60"></el-table-column>
			<el-table-column prop="order_id" label="交易编号" sortable></el-table-column>
			<el-table-column prop="created_print" label="交易时间" sortable></el-table-column>
<!--			<el-table-column prop="age" label="交易类型" width="120" sortable></el-table-column>-->
			<el-table-column prop="num" label="购买数量" width="120" sortable></el-table-column>
			<el-table-column prop="current_balance" label="购买后余额" min-width="180" sortable></el-table-column>
<!--			<el-table-column label="操作" width="150">-->
<!--				<template scope="scope">-->
<!--					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">查看</el-button>-->
<!--				</template>-->
<!--			</el-table-column>-->
		</el-table>
		<el-pagination layout="prev, pager, next, sizes, total"
					   @current-change="handleCurrentChange"
					   @size-change="handleSizeChange"
					   :page-size="rows" :total="total"
					   style="float:right;">
		</el-pagination>

	</section>

</template>

<script>
	import util from '../../common/js/util'
	// import store from '../vuex/store'
	//import NProgress from 'nprogress'
	import FileSaver from "file-saver";
	import XLSX from "xlsx";
	export default {
		data() {
			return {
				filters: {
					order_id: '',
					num:"",
				},
				buyTime:"",
				user: JSON.parse(sessionStorage.getItem('user')),
				userInfo: {},
				h:0,
				purchaserRecordList: [],
				total: 0,
				page: 1,
				rows: 20,
				loading: false,
				merchantFormVisible: false,//编辑界面是否显示
				merchantForm:{},
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				}
			}
		},
		beforeMount() {
			this.h = document.body.clientHeight - 61 - 200;
		},
		methods: {
			handleExport(){
				if(this.purchaserRecordList.length==0) return ;
				/* 从表生成工作簿对象 */
				let wb = XLSX.utils.table_to_book(document.querySelector("#purchaserRecordList"));
				/* 获取二进制字符串作为输出 */
				let wbout = XLSX.write(wb, {
					bookType: "xlsx",
					bookSST: true,
					type: "array"
				});
				try {
					FileSaver.saveAs(
					//Blob 对象表示一个不可变、原始数据的类文件对象。
					//Blob 表示的不一定是JavaScript原生格式的数据。
					//File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
					//返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
					new Blob([wbout], { type: "application/octet-stream" }),
					//设置导出文件名称
					"购买记录.xlsx"
					);
				} catch (e) {
					if (typeof console !== "undefined") console.log(e, wbout);
				}
				return wbout;
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getBusinessPurchaserRecordList();
			},
			handleSizeChange(val){
				this.rows = val;
				this.getBusinessPurchaserRecordList();
			},
			getBusinessPurchaserRecordList() {
				let para = {
					page: this.page-1,
					rows: this.rows,
					order_id: this.filters.order_id,
					num: this.filters.num,
					start_time: this.buyTime? this.buyTime[0]:"",
					end_time: this.buyTime?this.buyTime[1]:""
				};
				this.loading = true;
				//NProgress.start();
				this.$Api.getBusinessPurchaserRecordList(para).then((res) => {
					this.total = res.total;
					this.purchaserRecordList = res.rows;
					this.loading = false;
					//NProgress.done();
				})
				.catch(err => {
					this.loading = false;
					this.$message({
						message: err,
						type: "error"
					});
				});
			},
			getUserInfo(){
				let _this = this;
				_this.$Api.getUserInfo().then(res => {
          _this.userInfo = res;
				})
				.catch(err => {
					_this.$message({
						message: err,
						type: "error"
					});
				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				this.merchantFormVisible = true;
				this.merchantForm = Object.assign({}, row);
			},
			selsChange: function (sels) {
				this.sels = sels;
			}
		},
		mounted() {
			this.getUserInfo();
			this.getBusinessPurchaserRecordList();
		}
	}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// purchaseEnquiry.vue?3aac886f